import { type RumConfig } from '@porsche-code/kado-rum-client';

const rumConfig: Omit<RumConfig, 'appVersion'> = {
  appId: process.env.REACT_APP_RUM_APP_ID!,
  identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID!,
};

export default rumConfig;
